<style lang="less">
.page--404 {
  height: 100%;
  text-align: center;
  color: #999;
  h1 {
    margin: 0;
    padding: 2rem 0 0;
    line-height: 1.2;
    font-size: 1.2rem;
  }
  .pathname {
    color: #c00;
    font-size: 0.3rem;
  }
}
</style>

<template>
  <div class="page--404">
    <h1>404</h1>
    <p class="pathname">{{pathname}}</p>
  </div>
</template>

<script>
export default {
  computed: {
    pathname() {
      return location.pathname;
    }
  }
};
</script>
